import React from "react";
import classNames from "classnames";
import {Checkbox, CircularProgress, withStyles} from "@material-ui/core";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";
import InputMaskCurrency from "../../../../../components/Input/InputMaskCurrency";

const TipoConsultaList = ({
  classes,
  listaModal,
  handleChangeCheckbox,
  handleChange,
  loadMore,
  lastScroll,
  loadingModal,
}) => {
  return (
    <div className={classes.content}>
      <div className={classes.titles}>
        <div className={classes.title}> Selecione o tipo de atendimento </div>
        <div className={classes.motivoCancelamentoValorTitles}>
          <div className={classNames(classes.title, classes.titleValor)}>
            Valor
          </div>
        </div>
      </div>
      <Scroll
        loadMore={loadMore}
        hasMore={!lastScroll}
        pageStart={0}
        initialLoad={false}
        className={classes.scrollContainerModelos}
      >
        {listaModal.length > 0 &&
          listaModal.map((itemLista, index) => (
            <div className={classes.linha} key={index}>
              <div className={classes.checkboxDescricao}>
                <Checkbox
                  color={"primary"}
                  onChange={() => handleChangeCheckbox(itemLista, index)}
                  checked={itemLista.agendamentoTipo.checked}
                />
                <div className={classes.agendamentoTipo}>
                  {itemLista.agendamentoTipo.descricao}
                </div>
              </div>
              <div className={classes.motivoCancelamentoValor}>
                <InputMaskCurrency
                  name={"valor"}
                  value={itemLista.valor === 0 ? "" : itemLista.valor}
                  className={classNames(
                    classes.inputValor,
                    !itemLista.agendamentoTipo.checked && classes.inputValorDesabilitado
                  )}
                  onChange={(e) => handleChange(e, itemLista, index)}
                  disabled={!itemLista.agendamentoTipo.checked}
                />
              </div>
            </div>
          ))}
        {loadingModal && (
          <div className={classes.contentLoading}>
            <CircularProgress />
          </div>
        )}
      </Scroll>
    </div>
  );
};

const styles = {
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
  },
  titles: {
    display: "flex",
    justifyContent: "space-between",
    background: "#fff",
    flexShrink: 0,
    paddingBottom: "4px",
  },
  title: {
    fontSize: "10px",
    color: "#868686",
  },
  titleValor: {
    width: "100%",
    maxWidth: "104px",
  },
  agendamentoTipo: {
    color: "#868686",
  },
  linha: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "4px",
  },
  inputValor: {
    background: "#F2F2F2",
    padding: "4px 4px 4px 8px",
    width: "90px",
    height: "30px",
    border: "1px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
  },
  checkboxDescricao: {
    display: "flex",
    alignItems: "center",
    "&>span": {
      color: "#868686",
    },
  },
  contentLoading: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  scrollContainerModelos: {
    flex: 1,
    minHeight: 0,
    maxHeight: "unset !important",
    overflowY: "auto !important",
  },
  inputValorDesabilitado: {
    color: "#E5E5E5",
  },
  motivoCancelamentoValorTitles: {
    gap: '8px',
    width: '120px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  motivoCancelamentoValor: {
    display: "flex",
    gap: "8px",
  },
  selectMotivo: {
    width: '100px',
    "&> div": {
      width: "100px",
      "&> div > div": {
        height: "40px",
      },
    },
  },
};

export default withStyles(styles)(TipoConsultaList);
